import { Routes, Route } from "react-router-dom";
import Home from "../pages/Home";
import ShareScreen from "../pages/Share";
import NotFoundScreen from "../pages/NotFound";
import ValidateComponent from "../pages/Validate";


export default function AppRoutes() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/share" element={<ShareScreen />} />
        <Route path="/validate" element={<ValidateComponent />} />
        <Route path="*" element={<NotFoundScreen/>} />
      </Routes>
    </>
  );
}
